{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -117.29405111513921,
              32.50542380460658
            ],
            [
              -117.24791016063199,
              26.542474114856716
            ],
            [
              -100.93869156210184,
              14.953492608539705
            ],
            [
              -79.25548839658953,
              6.494004270715763
            ],
            [
              -95.37095147899674,
              1.3625640683994362
            ],
            [
              -80.106898081393,
              -24.330147364741364
            ],
            [
              -77.29331221814203,
              -62.08905858284448
            ],
            [
              -25.162307577628354,
              -56.71387815902105
            ],
            [
              -29.8418425576985,
              -2.9561142012951933
            ],
            [
              -58.781026299249746,
              11.107036644284236
            ],
            [
              -69.9970011668357,
              14.186363330548488
            ],
            [
              -77.63505683458095,
              11.509613475986683
            ],
            [
              -82.86904355387725,
              17.527357045113106
            ],
            [
              -86.75785182823932,
              22.7039901712662
            ],
            [
              -96.86320363159808,
              25.81678181545101
            ],
            [
              -117.29405111513921,
              32.50542380460658
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}